// // // // // import { Link } from "react-router-dom";
// // // // // import { Sparkles, ArrowRight } from "lucide-react";

// // // // // export default function Quotations() {
// // // // //   return (
// // // // //     <div>
// // // // //       <h1 className="text-3xl font-extrabold text-gray-900">Quotations</h1>
// // // // //       <p className="text-gray-600 mt-1 mb-6">Live module preview</p>

// // // // //       <div className="bg-gray-50 border border-gray-100 rounded-2xl px-6 py-16 flex flex-col items-center text-center">
// // // // //         <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-indigo-500 to-purple-600 flex items-center justify-center mb-6">
// // // // //           <Sparkles className="w-6 h-6 text-white" />
// // // // //         </div>

// // // // //         <h2 className="text-2xl font-extrabold text-gray-900 mb-4">Quotations</h2>

// // // // //         <p className="text-gray-500 max-w-xl mb-8">
// // // // //           This module is part of the ProtoHub MVP scaffold — data schema,
// // // // //           workflows and role permissions are wired. Full UI is being rolled
// // // // //           out module-by-module across the next releases.
// // // // //         </p>

// // // // //         <div className="flex flex-wrap items-center justify-center gap-3">
// // // // //           <Link
// // // // //             to="/app/dashboard"
// // // // //             className="bg-white border border-gray-200 text-gray-900 font-semibold text-sm px-5 py-2.5 rounded-xl hover:bg-gray-100 transition"
// // // // //           >
// // // // //             Innovator Home
// // // // //           </Link>
          
// // // // //            <a href="#apic-admin"
// // // // //             className="flex items-center gap-2 bg-gradient-to-r from-indigo-600 to-purple-600 text-white font-semibold text-sm px-5 py-2.5 rounded-xl hover:opacity-90 transition"
// // // // //           >
// // // // //             APIC Admin
// // // // //             <ArrowRight className="w-4 h-4" />
// // // // //           </a>
// // // // //         </div>
// // // // //       </div>
// // // // //     </div>
// // // // //   );
// // // // // }



// // // // import { useState } from "react";
// // // // import { Search } from "lucide-react";
// // // // import QuotationCard from "../components/modules/quotations/QuotationCard";
// // // // import quotationsData from "../data/quotationsData";

// // // // const filters = ["All", "Pending Review", "Approved", "Rejected", "Expired"];

// // // // export default function Quotations() {
// // // //   const [query, setQuery] = useState("");
// // // //   const [activeFilter, setActiveFilter] = useState("All");

// // // //   const filtered = quotationsData.filter((q) => {
// // // //     const matchesFilter = activeFilter === "All" || q.status === activeFilter;
// // // //     const matchesQuery =
// // // //       q.projectTitle.toLowerCase().includes(query.toLowerCase()) ||
// // // //       q.id.toLowerCase().includes(query.toLowerCase());
// // // //     return matchesFilter && matchesQuery;
// // // //   });

// // // //   const pendingCount = quotationsData.filter((q) => q.status === "Pending Review").length;
// // // //   const totalApprovedValue = quotationsData
// // // //     .filter((q) => q.status === "Approved")
// // // //     .reduce((sum, q) => sum + q.amount, 0);

// // // //   return (
// // // //     <div>
// // // //       <h1 className="text-3xl font-extrabold text-gray-900">Quotations</h1>
// // // //       <p className="text-gray-600 mt-1 mb-6">
// // // //         Review and approve cost estimates for your prototype requests.
// // // //       </p>

// // // //       {/* Summary stats */}
// // // //       <div className="grid sm:grid-cols-3 gap-4 mb-6">
// // // //         <div className="bg-white border border-gray-100 rounded-2xl p-5">
// // // //           <p className="text-xs font-semibold text-gray-400 tracking-wide mb-2">TOTAL QUOTATIONS</p>
// // // //           <p className="text-2xl font-extrabold text-gray-900">{quotationsData.length}</p>
// // // //         </div>
// // // //         <div className="bg-white border border-gray-100 rounded-2xl p-5">
// // // //           <p className="text-xs font-semibold text-gray-400 tracking-wide mb-2">AWAITING YOUR REVIEW</p>
// // // //           <p className="text-2xl font-extrabold text-orange-600">{pendingCount}</p>
// // // //         </div>
// // // //         <div className="bg-white border border-gray-100 rounded-2xl p-5">
// // // //           <p className="text-xs font-semibold text-gray-400 tracking-wide mb-2">APPROVED VALUE</p>
// // // //           <p className="text-2xl font-extrabold text-gray-900">
// // // //             ₹{totalApprovedValue.toLocaleString("en-IN")}
// // // //           </p>
// // // //         </div>
// // // //       </div>

// // // //       {/* Search + filters */}
// // // //       <div className="bg-white border border-gray-100 rounded-2xl p-4 mb-6">
// // // //         <div className="flex items-center gap-2 bg-gray-50 border border-gray-200 rounded-xl px-4 py-2.5 mb-4">
// // // //           <Search className="w-4 h-4 text-gray-400" />
// // // //           <input
// // // //             value={query}
// // // //             onChange={(e) => setQuery(e.target.value)}
// // // //             placeholder="Search by project name or quotation ID..."
// // // //             className="w-full bg-transparent text-sm focus:outline-none"
// // // //           />
// // // //         </div>

// // // //         <div className="flex flex-wrap gap-2">
// // // //           {filters.map((f) => {
// // // //             const isActive = activeFilter === f;
// // // //             return (
// // // //               <button
// // // //                 key={f}
// // // //                 type="button"
// // // //                 onClick={() => setActiveFilter(f)}
// // // //                 className={`text-sm font-medium px-4 py-1.5 rounded-full border transition ${
// // // //                   isActive
// // // //                     ? "bg-indigo-600 border-indigo-600 text-white"
// // // //                     : "bg-white border-gray-200 text-gray-700 hover:border-indigo-300"
// // // //                 }`}
// // // //               >
// // // //                 {f}
// // // //               </button>
// // // //             );
// // // //           })}
// // // //         </div>
// // // //       </div>

// // // //       {/* List */}
// // // //       {filtered.length > 0 ? (
// // // //         <div className="space-y-5">
// // // //           {filtered.map((q) => (
// // // //             <QuotationCard key={q.id} quotation={q} />
// // // //           ))}
// // // //         </div>
// // // //       ) : (
// // // //         <div className="h-40 flex items-center justify-center text-gray-400 border border-dashed border-gray-200 rounded-2xl">
// // // //           No quotations match your search.
// // // //         </div>
// // // //       )}
// // // //     </div>
// // // //   );
// // // // }





// // // import React, { useState } from "react";
// // // import "../../Users/components/modules/SalesManagment/SalesManagment.css";
// // // import SalesManagmentall from "../../Users/components/modules/SalesManagment/SalesManagmentall.jsx"
// // // import Salsemannger from "../../Users/components/modules/SalesManagment/Salsemannger.jsx";
// // // // import LeadsOrders from "../Ordermanagment/Caterings/LeadsOrders.js";

// // // /* ---------- Dummy Section Component ---------- */
// // // const DummySection = ({ title }) => {
// // //   return (
// // //     <div className="dummy-box">
// // //       <h2>{title}</h2>
// // //       <p>This is a dummy section for <strong>{title}</strong>.</p>
// // //       <span>Content will be added later 🚧</span>
// // //     </div>
// // //   );
// // // };

// // // /* ---------- Main Company Component ---------- */
// // // const Quotations = () => {

// // //   const tabs = [
// // //     // { id: 8, name: "Leads Orders", component: () => <LeadsOrders title="LeadsOrders" /> },

// // //     { id: 9, name: "Sales Executive", component: () => <SalesManagmentall title="Newdashbord" /> },
// // //     { id: 7, name: "Manager", component: () => <Salsemannger title="Sourcing" /> },
  
// // //   ];

// // //   const [activeTab, setActiveTab] = useState(tabs[0].id);
// // //   const ActiveComponent = tabs.find(tab => tab.id === activeTab)?.component;

// // //   return (
// // //     <div className="company-container">

// // //       {/* 🔹 Inline CSS */}
// // //       <style>{`
// // //         .company-scroll-container {
// // //           position: static;
// // //           background: #fff;
// // //           overflow-x: auto;
// // //         }

// // //         .company-buttons-row {
// // //           display: flex;
// // //           flex-wrap: nowrap;
// // //           gap: 8px;
// // //         }

// // //         .company-button {
// // //           padding: 8px 16px;
// // //           border: none;
// // //           background: #f0f0f0;
// // //           cursor: pointer;
// // //           border-radius: 6px;
// // //           white-space: nowrap;
// // //           font-size: 14px;
// // //         }

// // //         .company-button.active {
// // //           background: #4f46e5;
// // //           color: #fff;
// // //         }

// // //         .dummy-box{
// // //           padding:40px;
// // //           text-align:center;
// // //         }

// // //         /* Desktop Sticky */
// // //         @media (min-width: 769px) {
// // //           .company-scroll-container {
// // //             position: sticky;
// // //             top: 0;
// // //           }
// // //         }
// // //       `}</style>

// // //       {/* Tabs */}
// // //       <div className="company-scroll-container">
// // //         <div className="company-buttons-row">
// // //           {tabs.map(tab => (
// // //             <button
// // //               key={tab.id}
// // //               className={`company-button ${activeTab === tab.id ? "active" : ""}`}
// // //               onClick={() => setActiveTab(tab.id)}
// // //             >
// // //               {tab.name}
// // //             </button>
// // //           ))}
// // //         </div>
// // //       </div>

// // //       {/* Active Section */}
// // //       <div className="component-display">
// // //         {ActiveComponent && <ActiveComponent />}
// // //       </div>

// // //     </div>
// // //   );
// // // };

// // // export default Quotations;





// // import { useNavigate } from "react-router-dom";
// // import quotationsData from "../data/quotationsData";

// // function money(n) {
// //   return `₹${n.toLocaleString("en-IN")}`;
// // }

// // const statusStyles = {
// //   Draft: "bg-gray-100 text-gray-600",
// //   Published: "bg-blue-50 text-blue-700",
// //   "Quotations Received": "bg-indigo-50 text-indigo-700",
// //   "Under Evaluation": "bg-amber-50 text-amber-700",
// //   "Quotation Selected": "bg-emerald-50 text-emerald-700",
// //   "Work Order Initiated": "bg-emerald-50 text-emerald-700",
// //   "In Development": "bg-emerald-50 text-emerald-700",
// //   Completed: "bg-gray-100 text-gray-600",
// // };

// // export default function Quotations() {
// //   const navigate = useNavigate();

// //   const openEnquiries = quotationsData.filter((q) =>
// //     ["Draft", "Published"].includes(q.status)
// //   ).length;
// //   const quotationsReceived = quotationsData.filter(
// //     (q) => q.status === "Quotations Received"
// //   ).length;
// //   const underEvaluation = quotationsData.filter(
// //     (q) => q.status === "Under Evaluation"
// //   ).length;
// //   const selected = quotationsData.filter(
// //     (q) => q.status === "Quotation Selected"
// //   ).length;
// //   const activeProjects = quotationsData.filter((q) =>
// //     ["Work Order Initiated", "In Development"].includes(q.status)
// //   ).length;

// //   const stats = [
// //     { label: "Open Enquiries", value: openEnquiries },
// //     { label: "Quotations Received", value: quotationsReceived },
// //     { label: "Under Evaluation", value: underEvaluation },
// //     { label: "Selected", value: selected },
// //     { label: "Active Projects", value: activeProjects },
// //   ];

// //   return (
// //     <div>
// //       <h1 className="text-3xl font-extrabold text-gray-900">Quotations</h1>
// //       <p className="text-gray-600 mt-1 mb-6">
// //         Track open enquiries and compare quotations from Centres & Vendors
// //       </p>

// //       {/* Summary stats */}
// //      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 mb-6">
// //         {stats.map((s) => (
// //           <div
// //             key={s.label}
// //             className="bg-white border border-gray-100 rounded-2xl p-3"
// //           >
// //             <p className="text-xs font-semibold text-gray-400 tracking-wide">
// //               {s.label.toUpperCase()}
// //             </p>
// //             <p className="text-2xl font-extrabold text-gray-900">{s.value}</p>
// //           </div>
// //         ))}
// //       </div>

// //       {/* Table */}
// //       <div className="bg-white border border-gray-100 rounded-2xl overflow-auto mb-8">
// //         <table className="w-full text-sm">
// //           <thead style={{backgroundColor:"#f9fbfe"}}>
// //             <tr className="border-b border-gray-100 text-left text-xs font-semibold text-gray-400 tracking-wide">
// //               <th className="px-5 py-3">Enquiry</th>
// //               <th className="px-5 py-3">Category</th>
// //               <th className="px-5 py-3">Budget</th>
// //               <th className="px-5 py-3">Target</th>
// //               <th className="px-5 py-3">Quotations</th>
// //               <th className="px-5 py-3">Status</th>
// //               <th className="px-5 py-3">Actions</th>
// //             </tr>
// //           </thead>
// //           <tbody>
// //             {quotationsData.length === 0 ? (
// //               <tr>
// //                 <td colSpan={7} className="px-5 py-10 text-center text-gray-400">
// //                   No enquiries yet. Start by creating a new prototype request.
// //                 </td>
// //               </tr>
// //             ) : (
// //               quotationsData.map((q) => (
// //                 <tr
// //                   key={q.id}
// //                   className="border-b border-gray-50 last:border-0 hover:bg-gray-50/60 transition"
// //                 >
// //                   <td className="px-5 py-4" style={{ whiteSpace:"nowrap"}}>
// //                     <p className="font-semibold text-gray-900">{q.title}</p>
// //                     <p className="text-xs text-gray-400">{q.id}</p>
// //                   </td>
// //                   <td className="px-5 py-4 text-gray-600">{q.category}</td>
// //                   <td className="px-5 py-4 text-gray-600 whitespace-nowrap">
// //                     {money(q.budgetMin)} – {money(q.budgetMax)}
// //                   </td>
// //                   <td className="px-5 py-4 text-gray-600 whitespace-nowrap">
// //                     {q.targetDate}
// //                   </td>
// //                   <td className="px-5 py-4 text-gray-600">
// //                     {q.quotes.length}
// //                   </td>
// //                   <td className="px-5 py-4">
// //                     <span
// //                       className={`text-xs font-semibold px-2.5 py-1 rounded-full whitespace-nowrap ${
// //                         statusStyles[q.status] || "bg-gray-100 text-gray-600"
// //                       }`}
// //                     >
// //                       {q.status}
// //                     </span>
// //                   </td>
// //                   <td className="px-5 py-4">
// //                     <button
// //                       type="button"
// //                      onClick={() => navigate(`/app/quotations/${q.id}`)}
// //                       className="inline-flex items-center justify-center gap-2 whitespace-nowrap font-medium cursor-pointer transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 disabled:cursor-not-allowed [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 border border-input bg-background shadow-sm hover:bg-accent hover:text-accent-foreground h-8 rounded-md px-3 text-xs"
// //                     >
// //                       Compare  →
// //                     </button>
// //                   </td>
// //                 </tr>
// //               ))
// //             )}
// //           </tbody>
// //         </table>
// //       </div>

// //       {/* Feature callouts */}
// //       <div className="grid sm:grid-cols-3 gap-4">
// //         <div className="bg-white border border-gray-100 rounded-2xl p-5">
// //           <p className="font-semibold text-gray-900 mb-1">Fair comparison</p>
// //           <p className="text-sm text-gray-500">
// //             See material, manufacturing, tooling and GST breakdown side-by-side.
// //           </p>
// //         </div>
// //         <div className="bg-white border border-gray-100 rounded-2xl p-5">
// //           <p className="font-semibold text-gray-900 mb-1">Faster procurement</p>
// //           <p className="text-sm text-gray-500">
// //             Multiple Centres respond in parallel — no back-and-forth phone calls.
// //           </p>
// //         </div>
// //         <div className="bg-white border border-gray-100 rounded-2xl p-5">
// //           <p className="font-semibold text-gray-900 mb-1">Verified Centres</p>
// //           <p className="text-sm text-gray-500">
// //             Every APIC Centre and eligible Vendor is admin-approved.
// //           </p>
// //         </div>
// //       </div>
// //     </div>
// //   );
// // }


// // Quotations.jsx
// import { useState } from "react";
// import QuotationsPending from "../components/modules/quotations/QuotationsPending";
// import QuotationsInProgress from "../components/modules/quotations/QuotationsInProgress";

// export default function Quotations() {
//   const [activeTab, setActiveTab] = useState("pending");

//   return (
//     <div>
//       <h1 className="text-3xl font-extrabold text-gray-900">Quotations</h1>
//       <p className="text-gray-600 mt-1 mb-6">
//         Track open enquiries and compare quotations from Centres & Vendors
//       </p>

//       {/* Tabs */}
//       <div className="flex gap-1 bg-gray-100 rounded-xl p-1 mb-6 w-fit">
//         <button
//           onClick={() => setActiveTab("pending")}
//           className={`px-6 py-2.5 rounded-lg text-sm font-semibold transition ${
//             activeTab === "pending"
//               ? "bg-white text-indigo-600 shadow-sm"
//               : "text-gray-500 hover:text-gray-700"
//           }`}
//         >
//           Pending Quotations
//         </button>
//         <button
//           onClick={() => setActiveTab("inProgress")}
//           className={`px-6 py-2.5 rounded-lg text-sm font-semibold transition ${
//             activeTab === "inProgress"
//               ? "bg-white text-indigo-600 shadow-sm"
//               : "text-gray-500 hover:text-gray-700"
//           }`}
//         >
//           In Progress
//         </button>
//       </div>

//       {/* Tab Content */}
//       {activeTab === "pending" ? <QuotationsPending /> : <QuotationsInProgress />}

//       {/* Feature callouts */}
//       <div className="grid sm:grid-cols-3 gap-4 mt-6">
//         <div className="bg-white border border-gray-100 rounded-2xl p-5">
//           <p className="font-semibold text-gray-900 mb-1">Fair comparison</p>
//           <p className="text-sm text-gray-500">
//             See material, manufacturing, tooling and GST breakdown side-by-side.
//           </p>
//         </div>
//         <div className="bg-white border border-gray-100 rounded-2xl p-5">
//           <p className="font-semibold text-gray-900 mb-1">Faster procurement</p>
//           <p className="text-sm text-gray-500">
//             Multiple Centres respond in parallel — no back-and-forth phone calls.
//           </p>
//         </div>
//         <div className="bg-white border border-gray-100 rounded-2xl p-5">
//           <p className="font-semibold text-gray-900 mb-1">Verified Centres</p>
//           <p className="text-sm text-gray-500">
//             Every APIC Centre and eligible Vendor is admin-approved.
//           </p>
//         </div>
//       </div>
//     </div>
//   );
// }


// Quotations.jsx
import { useState } from "react";
import { FileText, Clock, CheckCircle } from "lucide-react";
import QuotationsPending from "../components/modules/quotations/QuotationsPending";
import QuotationsInProgress from "../components/modules/quotations/QuotationsInProgress";
import quotationsData from "../data/quotationsData";

const tabs = [
  { id: "pending", label: "Pending Quotations", icon: FileText },
  { id: "inProgress", label: "In Progress", icon: Clock },
];

export default function Quotations() {
  const [activeTab, setActiveTab] = useState("pending");

  // Counts for each tab
  const counts = {
    pending: quotationsData.filter((q) => ["Draft", "Published"].includes(q.status)).length,
    inProgress: quotationsData.filter((q) =>
      ["Quotations Received", "Under Evaluation", "Quotation Selected", "Work Order Initiated", "In Development"].includes(q.status)
    ).length,
  };

  return (
    <div>
      <h1 className="text-3xl font-extrabold text-gray-900">Quotations</h1>
      <p className="text-gray-600 mt-1 mb-6">
        Track open enquiries and compare quotations from Centres & Vendors
      </p>

      {/* Tabs - Matching BookingTabs style */}
      <div className="flex flex-wrap gap-2 mb-6">
        {tabs.map(({ id, label, icon: Icon }) => {
          const isActive = activeTab === id;
          return (
            <button
              key={id}
              type="button"
              onClick={() => setActiveTab(id)}
              className={`flex items-center gap-2 text-sm font-semibold px-4 py-2.5 rounded-lg border transition ${
                isActive
                  ? "bg-indigo-600 border-indigo-600 text-white"
                  : "bg-white border-gray-200 text-gray-700 hover:border-indigo-300"
              }`}
            >
              <Icon className="w-4 h-4" />
              {label}
              <span
                className={`text-xs font-bold px-1.5 py-0.5 rounded-full ${
                  isActive ? "bg-white/20" : "bg-gray-100 text-gray-500"
                }`}
              >
                {counts[id]}
              </span>
            </button>
          );
        })}
      </div>

      {/* Tab Content */}
      {activeTab === "pending" ? <QuotationsPending /> : <QuotationsInProgress />}

      {/* Feature callouts */}
      <div className="grid sm:grid-cols-3 gap-4 mt-6">
        <div className="bg-white border border-gray-100 rounded-2xl p-5">
          <p className="font-semibold text-gray-900 mb-1">Fair comparison</p>
          <p className="text-sm text-gray-500">
            See material, manufacturing, tooling and GST breakdown side-by-side.
          </p>
        </div>
        <div className="bg-white border border-gray-100 rounded-2xl p-5">
          <p className="font-semibold text-gray-900 mb-1">Faster procurement</p>
          <p className="text-sm text-gray-500">
            Multiple Centres respond in parallel — no back-and-forth phone calls.
          </p>
        </div>
        <div className="bg-white border border-gray-100 rounded-2xl p-5">
          <p className="font-semibold text-gray-900 mb-1">Verified Centres</p>
          <p className="text-sm text-gray-500">
            Every APIC Centre and eligible Vendor is admin-approved.
          </p>
        </div>
      </div>
    </div>
  );
}